<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <div class="col-span-12 lg:col-span-10">
            <page-loading v-if="!orgUnit"></page-loading>
            <template v-else>
                <org-unit-billing-details :orgUnit="orgUnit" :isAdminOrOwner="isAdminOrOwner" />
            </template>
        </div>
    </org-unit-details>
</template>

<script setup>
import OrgUnitBillingDetails from './OrgUnitBillingDetails.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import OrgUnitDetails from '../form/OrgUnitDetails.vue';
import { ref, onMounted } from 'vue';
import { orgUnitsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const orgUnit = ref(null);
const isAdminOrOwner = Spark.isAdminOrOwner;
const $toasted = useToasted();

const getOrgUnit = async () => {
    try {
        const response = await orgUnitsClient.showOrgUnit(props.teamId, props.orgUnitId);
        orgUnit.value = response.data;
    } catch (error) {
        console.error('Failed to fetch org unit:', error);
        $toasted.error('Failed to load organizational unit details. Please try again.');
    }
};

onMounted(() => {
    getOrgUnit();
});
</script>
